import { DefaultLoadingComponent } from "../../../../global/defaultLoading/DefaultLoadingComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { HeadlineMediumProminent } from "../../../../global/ui/typography";

export const ListingHeaderTitle = ({}) => {
  const loading = useSelector((state: RootState) => state.trainingPlan.loading);
  const listing = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  if (loading) {
    return <DefaultLoadingComponent width={200} height={30} />;
  }

  return <HeadlineMediumProminent>{listing?.title}</HeadlineMediumProminent>;
};
